export const MotionStatus = {
    InMotion: 'In Transit',
    AtOrigin: 'At Origin',
    AtDestination: 'At Destination'
};

export const MotionStatuses = [
    MotionStatus.AtDestination,
    MotionStatus.AtOrigin,
    MotionStatus.InMotion
];
